import { NgModule } from '@angular/core';
import { LibChevronIconComponent } from './lib-chevron-icon.component';

@NgModule({
  declarations: [LibChevronIconComponent],
  imports: [],
  exports: [LibChevronIconComponent],
})
export class LibChevronIconModule {}
